import { render } from "./WidgetSearchBhagIntranet.vue?vue&type=template&id=67ff71b1&scoped=true&ts=true"
import script from "./WidgetSearchBhagIntranet.vue?vue&type=script&lang=ts"
export * from "./WidgetSearchBhagIntranet.vue?vue&type=script&lang=ts"

import "./WidgetSearchBhagIntranet.vue?vue&type=style&index=0&id=67ff71b1&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ff71b1"]])

export default __exports__